//import * as defaults from './Defaults'
import storage from 'redux-persist/lib/storage';
import { configuration } from './Defaults';
import { ValidationError } from 'yup';

export const routesIndex = {
    app: {
        home: '/' // + (process.env.APP_ALIAS ?? '')
        , authentication: '/autenticazione' //'/' + (process.env.APP_ALIAS ?? '') + 'authentication'
        , registration: '/registrazione'
        //, users: '/utenti' //'/' + (process.env.APP_ALIAS ?? '') + 'users'
        , anythingelse: '/*' // '/' + (process.env.APP_ALIAS ?? '') + '*'
        , me: '/profiloutente' //'/me'
        , forgotpassword : '/passworddimenticata'
        , forgotpasswordconfirmation :'/confermapassword'
        , resetpassword : '/resetpassword'

        , associations: '/associations'
        , members: '/members'
        , search: '/search'

        , memberships: {
            root: '/memberships',
            add: '/memberships/add',
            details: '/memberships/:id',
            online: '/memberships/online',
            toReview: '/memberships/to-review',
            multiple: '/memberships/multiple',
            tipografia: '/memberships/tipografia',
            cumulative: {
                root: '/memberships/cumulative',
                details: '/memberships/cumulative/:id',
            },
        }

        , adminpanel: '/admin/dashboard'
        , reports: '/reports'
        , singleMembershipRequests: '/single-membership-requests'
        , bulkMembershipStocks:  '/memberships/cumulative'
        , membershipRequests: '/membership-requests'
        , emailRegions: '/email-regions'
        , emailProvinces: '/email-provinces'
        , resoconti: '/resoconti'
        /** Coerenza dati: voce nel menu profilo (topbar) solo ROLE_ADMIN; rotta protetta in frontend */
        , dataConsistency: '/data-consistency'
        , adesioniSessionRecovery: '/adesioni-session-recovery'
        , emailTemplates: {
            root: '/email-templates',
            compose: '/email-templates/compose',
        }
        
        

        // APP CUSTOM
        
        , storage: {
            root: '..' + (window.location.pathname != '/' + (process.env.APP_ALIAS ?? '') ? '/..' : '') + (process.env.APP_ALIAS ?? '') + '/' + 'storage' // '../storage' // 
            , events: '../storage/events'
            , accounts: '../storage/accounts'
            , partnershiplists: '../storage/partnershiplists'
        }
    },
   
    api: {
        prefix: (process.env.APP_ALIAS ?? '') + '/api',
        
        methods: {
            index:              '/index'
            , store:            '/store'
            , update:           '/update'
            , destroy:          '/destroy'

            , search:           '/search'
            , paginate:         '/paginate'
            , view:             '/view'
            , fulltextsearch:   '/fulltextsearch'
            , filter:           '/filter'
            , create:           '/create'
            , activate:         '/activate'

            , realtime:         '/realtime'
            , import:           '/import'
            , export:           '/export'
            , validation:       '/validation'
            , notify:           '/notify'
            , archive:          '/archive'
            , check:            '/check'
            , last:             '/last'
            , fileopen:         '/fileopen'
            , filedownload:     '/filedownload'
            , fileget:          '/fileget'
            , fileupload:       '/fileupload'
            , run:              '/run'
            , restore:          '/restore' 
            , delete:           '/delete'
            , send:             '/send'
            , count:            '/count'

            , profileinformation: '/profile-information'
            
        },

        emails: {
            index: (process.env.APP_ALIAS ?? '') + '/api/emails/index'
            , store: (process.env.APP_ALIAS ?? '') + '/api/emails/store'
            , update: (process.env.APP_ALIAS ?? '') + '/api/emails/update'
            , view: (process.env.APP_ALIAS ?? '') + '/api/emails/view'
            , recent: (process.env.APP_ALIAS ?? '') + '/api/emails/recent'
            , search: (process.env.APP_ALIAS ?? '') + '/api/emails/search'
            , owned: (process.env.APP_ALIAS ?? '') + '/api/emails/owned'
            , destroy : (process.env.APP_ALIAS ?? '') + '/api/emails/destroy'
            , paginate : (process.env.APP_ALIAS ?? '') + '/api/emails/paginate'
            , monthReport : (process.env.APP_ALIAS ?? '') + '/api/emails/month-report'
            , monthReportAlert : (process.env.APP_ALIAS ?? '') + '/api/emails/month-report-alert'    
            , sendReport : (process.env.APP_ALIAS ?? '') + '/api/emails/send-report'
            , viewReport : (process.env.APP_ALIAS ?? '') + '/api/emails/view-report'
            , sendTestReport : (process.env.APP_ALIAS ?? '') + '/api/emails/send-test-report'


            , brevoSendTransactionalEmail : (process.env.APP_ALIAS ?? '') + '/api/emails/brevo-send-transactional-email'
            , brevoCreateEmailJob : (process.env.APP_ALIAS ?? '') + '/api/emails/brevo-create-email-job'
            , brevoSendEmailTemplate : (process.env.APP_ALIAS ?? '') + '/api/emails/brevo-send-email-template'
            , brevoShowEmailJob : (process.env.APP_ALIAS ?? '') + '/api/emails/brevo-email-job-show'
            , fetchRecipientCount : (process.env.APP_ALIAS ?? '') + '/api/emails/fetch-recipient-count'
        },

        system: {
            root: '/settings',

            status: '/system-status',
            enable: '/system-enable',
            disable: '/system-disable',

            year: '/system-year',
            yearUpdate: '/system-year',
            yearEnable: '/system-year-enabled',
            yearDisable: '/system-year-disable',

            resocontiYear: '/resoconti-year',

            documentsImport: '/system-documents-import', //'/system-documents-import'
        },

        /*
        users: {
            index: (process.env.APP_ALIAS ?? '') + '/api/users' //'/api/users' //
            , store: (process.env.APP_ALIAS ?? '') + '/api/register' //'/api/register' //
            , view: (process.env.APP_ALIAS ?? '') + '/api/users/view' //'/api/users/view' //
            , update: (process.env.APP_ALIAS ?? '') + '/api/users/update'
            , destroy: (process.env.APP_ALIAS ?? '') + '/api/users/destroy'
            , create: (process.env.APP_ALIAS ?? '') + '/api/users/create'
            , activate: (process.env.APP_ALIAS ?? '') + '/api/users/activate'
            , search: (process.env.APP_ALIAS ?? '') + '/api/users/search'
            , paginate: (process.env.APP_ALIAS ?? '') + '/api/users/paginate'
        },
        */
       users: '/users',
           
        authentication: {
            csrf: '/sanctum/csrf-cookie' //'/sanctum/csrf-cookie' //
            , login: '/login'
            , user: '/user'
            , logout: '/logout'
            , forgotpassword: '/forgot-password'
            , resetpassword: '/reset-password'
            , twofactorchallenge: '/two-factor-challenge'
            , twofactorauthentication: '/user/two-factor-authentication'
            , twofactorqrcode: '/user/two-factor-qr-code'
        },

       
        dictionary: {
            root: '/api/dictionary',
        },


       
        settings : {
            root: '/settings'

            , tools: '/tools'
        },

        // accounts: '/accounts',
        
        accounts: {
            index: (process.env.APP_ALIAS ?? '') + '/api/accounts/index'
            , store: (process.env.APP_ALIAS ?? '') + '/api/accounts/store'
            , view: (process.env.APP_ALIAS ?? '') + '/api/accounts/view'
            , update: (process.env.APP_ALIAS ?? '') + '/api/accounts/update'
            , destroy: (process.env.APP_ALIAS ?? '') + '/api/accounts/destroy'
            , create: (process.env.APP_ALIAS ?? '') + '/api/accounts/create'
            , activate: (process.env.APP_ALIAS ?? '') + '/api/accounts/activate'
            , search: (process.env.APP_ALIAS ?? '') + '/api/accounts/search'
            , paginate: (process.env.APP_ALIAS ?? '') + '/api/accounts/paginate'
            , filter: (process.env.APP_ALIAS ?? '') + '/api/accounts/filter'
            , fulltextsearch: (process.env.APP_ALIAS ?? '') + '/api/accounts/fulltextsearch'
        },

        associations: '/associations',
        members: '/members',
        memberships: '/memberships',
        search: '/search',

        // search: {
        //     invoke: (process.env.APP_ALIAS ?? '') + '/api/search'
        // },
        

        semaphore: '/semaphore',
        dataConsistency: {
            searchMembers: '/data-consistency/search-members',
            userProfile: '/data-consistency/user',
            summary: '/data-consistency/summary',
            duplicateFiscalCodes: '/data-consistency/duplicate-fiscal-codes',
            singleRequestsAnomalies: '/data-consistency/single-requests-anomalies',
            membershipAnomalies: '/data-consistency/membership-anomalies',
            adesioniRecoverySearch: '/data-consistency/adesioni-recovery/search',
            adesioniRecoveryUploadDocument: '/data-consistency/adesioni-recovery/upload-document',
            adesioniRecoverySendEmail: '/data-consistency/adesioni-recovery/send-email',
            adesioniSessionRecoverySearch: '/data-consistency/adesioni-session-recovery/search',
            adesioniSessionRecoveryUploadDocument: '/data-consistency/adesioni-session-recovery/upload-document',
            adesioniSessionRecoveryCreateSmr: '/data-consistency/adesioni-session-recovery/create-smr',
            adesioniSessionRecoverySendEmail: '/data-consistency/adesioni-session-recovery/send-email',
            patchMember: '/data-consistency/patch-member',
            patchSmr: '/data-consistency/patch-smr',
            patchMembership: '/data-consistency/patch-membership',
        },
        reports: '/reports',
        dashboard: '/dashboard',
        singleMembershipRequests: '/single-membership-requests',
        bulkMembershipStocks:  '/bulk-membership-stocks',
        bulkMembershipRequests: '/bulk-membership-requests',
        membershipRequests: '/membership-requests',
        emailResoconti: '/email-resoconti',
        emailRegions: '/email-regions',
        emailProvinces: '/email-provinces',
        warehouse: '/warehouse',
        campaigns:'/membership-campaigns'
    },

    images: {
        logo: '../storage/assets/logo.png'
    }
    
}